module.exports = "<p>drr-filter-master-modal works!</p>\n"